import {
  apiDelete,
  apiGet,
  apiPatch,
  apiPost,
} from '~/_shared/utils/api/api.helpers';
import { newEntityAccessesToApiParams } from './entityAccess.repository.helpers';

export enum EntityAccessLevel {
  WRITE = 'write',
  READ = 'read',
}

export enum EntityType {
  MAP = 'map',
}

export enum SharedEntityType {
  USER = 'user',
}

export enum EntityAccessErrorCode {
  MAP_USED_AS_BASE_MAP = 'MAP_USED_AS_BASE_MAP',
}

export type EntityAccess = Readonly<{
  id: number;
  ownerId: number;
  entityType: EntityType;
  entityId: number;
  sharedEntityType: SharedEntityType;
  sharedEntityId: number;
  accessLevel: EntityAccessLevel;
  createdAt: string;
  updatedAt: string;
}>;

export type EntityAccessResponse = Readonly<{
  id: number;
  owner_id: number;
  entity_type: EntityType;
  entity_id: number;
  shared_entity_type: SharedEntityType;
  shared_entity_id: number;
  access_level: EntityAccessLevel;
  created_at: string;
  updated_at: string;
}>;

export type GetEntityAccessesResponse = Readonly<{
  list: ReadonlyArray<EntityAccessResponse>;
}>;

export type DeleteEntityAccessErrorResponse = Readonly<{
  code?: EntityAccessErrorCode;
}>;

export const getEntityAccessesRequest = (
  clientId: number,
  entityType?: EntityType,
  sharedEntityType?: SharedEntityType,
  accessLevel?: EntityAccessLevel,
  entityId?: number,
  sharedEntityId?: number,
): Promise<GetEntityAccessesResponse> => {
  const requestUrl = `/api/clients/${clientId}/accesses`;
  return apiGet(requestUrl, {
    entity_type: entityType,
    shared_entity_type: sharedEntityType,
    access_level: accessLevel,
    entity_id: entityId,
    shared_entity_id: sharedEntityId,
  });
};

export type NewEntityAccess = {
  accessLevel: EntityAccessLevel;
  entityId: number;
  entityType: EntityType;
  sharedEntityId: number;
  sharedEntityType: SharedEntityType;
};

export const createEntityAccessRequest = (clientId: number, newEntityAccesses: NewEntityAccess[]): Promise<void> => {
  const requestUrl = `/api/clients/${clientId}/accesses`;
  return apiPost(requestUrl, {
    params: newEntityAccessesToApiParams(newEntityAccesses),
  });
};

export const updateEntityAccessRequest = (
  clientId: number,
  entityAccessId: number,
  accessLevel: EntityAccessLevel
): Promise<void> => {
  const requestUrl = `/api/clients/${clientId}/accesses/${entityAccessId}`;
  return apiPatch(requestUrl, {
    access_level: accessLevel,
  });
};

export const deleteEntityAccessRequest = ({
  clientId,
  entityAccessId,
  overrideMapUsedAsBaseMap,
}: {
  clientId: number;
  entityAccessId: number;
  overrideMapUsedAsBaseMap?: boolean;
}): Promise<DeleteEntityAccessErrorResponse> => {
  const requestUrl = `/api/clients/${clientId}/accesses/${entityAccessId}`;
  return apiDelete(requestUrl, ({
    ...(overrideMapUsedAsBaseMap ? { override_map_used_as_base_map: true } : {}),
  }));
};
